import type { ToolMeta } from "../types";

export const toolMeta = {
  slug: "case-converter",
  title: "Case Converter",
  pageHeading: "Free Case Converter",
  description:
    "Use a free letter case converter for uppercase to lowercase, lowercase to uppercase, all caps to lowercase, title case, sentence case, and URL-safe formats.",
  seoTitle: "Free Case Converter: Uppercase, Lowercase & Title Case",
  seoDescription:
    "Convert text to uppercase, lowercase, title case, sentence case, camelCase, snake_case, kebab-case, and more with this free online case converter.",
  featureList: [
    "Uppercase and lowercase conversion",
    "Title case and sentence case conversion",
    "Capitalized, alternating, and inverse case",
    "camelCase and PascalCase conversion",
    "snake_case, kebab-case, and CONSTANT_CASE conversion",
    "Character and word counts",
  ],
  category: "Text",
} satisfies ToolMeta;
